// Statuses
import "./status-chip.scss";
import { normalizeStatusLabel } from "../../utils/normalize-status-label";

interface StatusChipProps {
	status: string;
	tooltip?: string;
}

export const StatusChip = ({ status, tooltip }: StatusChipProps) => {
	const label = normalizeStatusLabel(status);
	const modifier = label
		.toLowerCase()
		.replace(/\s+/g, "-")
		.trim();

	const chip = (
		<div className={`status-chip ${modifier}`}>
			<div>{label}</div>
		</div>
	);

	if (!tooltip) return chip;

	return (
		<div className='status-chip-host'>
			{chip}
			<div className='status-chip__tooltip' role='tooltip'>
				{tooltip}
			</div>
		</div>
	);
};
